import { render, staticRenderFns } from "./category-levels-assessment-mobile.vue?vue&type=template&id=5bd0f2ff&scoped=true&"
import script from "./category-levels-assessment-mobile.vue?vue&type=script&lang=ts&"
export * from "./category-levels-assessment-mobile.vue?vue&type=script&lang=ts&"
import style0 from "./category-levels-assessment-mobile.vue?vue&type=style&index=0&id=5bd0f2ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd0f2ff",
  null
  
)

export default component.exports